import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Cuándo recibo el material?',
  a: 'Recibirás los PDFs y enlaces a Google Docs/Sheets inmediatamente después de la compra.'
}, {
  q: '¿Necesito experiencia previa?',
  a: 'No. Está pensado para quien cocina en casa y quiere organizarse o dar los primeros pasos vendiendo.'
}, {
  q: '¿Puedo usarlo solo para mi casa?',
  a: 'Sí — funciona perfecto para planificar comidas semanales y ahorrar tiempo.'
}, {
  q: '¿En qué formatos está?',
  a: 'Ebook en PDF.'
}, {
  q: '¿Tiene garantía?',
  a: '2 días de garantía si no descargaste los materiales.'
}, {
  q: '¿Puedo utilizarlo desde el celular?',
  a: 'Si, podes utilizarlo desde el celular, tablet, computadora, etc.'
}, {
  q: '¿Las recetas son saludables?',
  a: 'Todas son saludables, equilibradas y pensadas para ofrecer los nutrientes y vitaminas que el cuerpo necesita.'
}, {
  q: '¿Los ingredientes son caros?',
  a: 'No, la propuesta de la guía es usar ingredientes simples, accesibles y fáciles de encontrar en cualquier supermercado o almacén de barrio. Nada de cosas importadas ni difíciles de conseguir.'
}, {
  q: '¿Necesito utensilios especiales?',
  a: 'No, con lo que ya tenés en tu cocina alcanza. Las recetas fueron pensadas para ser prácticas y accesibles, sin necesidad de equipos profesionales ni costosos.'
}];
export const FAQSection: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-24 px-4 md:px-8 bg-white" data-id="element-42">
      <div className="max-w-3xl mx-auto" data-id="element-43">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-44">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-primary mb-4" data-id="element-45">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-46">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05
        }} className="border border-brand-cream rounded-2xl overflow-hidden bg-brand-bg/50" data-id="element-47">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" data-id="element-48">
                <span className="font-bold text-brand-text-dark pr-4" data-id="element-49">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-brand-soft transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-50" />
              </button>
              <AnimatePresence data-id="element-51">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-52">
                    <div className="px-6 pb-4 text-brand-text-medium" data-id="element-53">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
};